import {Component, Inject, OnInit} from '@angular/core';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {DialogModel} from '@shared/models/dialog.model';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Subject} from 'rxjs';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    standalone: false,
    selector: 'particle-add-board-dialog',
  templateUrl: './add-board-dialog.component.html',
  styleUrls: ['./add-board-dialog.component.scss']
})
export class AddBoardDialogComponent implements OnInit, IDialogView {
  data: DialogModel;
  boardName: string;
  inputForm: FormGroup;
  inputFormError: any;
  unsubscribe$ = new Subject<void>();
  constructor(private formBuilder: FormBuilder, @Inject(MAT_DIALOG_DATA) public info: DialogModel) {
    this.inputFormError = {
      value: {}
    };
  }

  ngOnInit() {
    this.boardName = this.data.input.title;
    this.inputForm = this.formBuilder.group({
      value: [this.data.input.title, Validators.required]
    });
    if (this.data.input.title === '') {
      this.info.isDisabledOkButton = true;
    }
    this.inputForm.valueChanges.subscribe(() => {
      this.onFormValuesChanged();
    });
  }
  onOkClicked() {
    this.data.input.boardName = this.boardName;
    return true;
  }
  onFormValuesChanged () {
    for (const field in this.inputFormError) {
      if (!this.inputFormError.hasOwnProperty(field)) {
        continue;
      }
      this.inputFormError[field] = {};
      const control = this.inputForm.get(field);
      if (control && control.dirty && !control.valid) {
        this.inputFormError[field] = control.errors;
        this.info.isDisabledOkButton = true;
      } else {
        this.boardName = control.value.trim();
        this.info.isDisabledOkButton = !this.boardName;
        this.inputFormError.value.required = !this.boardName;
      }
    }
  }
}
